import { request } from '@/network/axios'

import { LoginParams } from './types'

enum APIS {
  GET_LOGIN_URL = '/v1/user/google/login',
}

export const googleLogin = async (params: LoginParams) => {
  const res = await request.get<string>(APIS.GET_LOGIN_URL, params)
  if (res) {
    localStorage.setItem('bobai-token', res)
    // 登录成功之后将数据发送给插件
    window.postMessage({
      type: 'LOGIN_SUCCESS',
      token: res,
    })
  }
  return res
}
